import * as R from 'ramda';
const getMonths = R.split(',', '01,02,03,04,05,06,07,08,09,10,11,12');

export default getMonths;